import { useState, useRef, useEffect } from "react";
import logo from "../assets/logos/logo.png";

function Contato() {
  //const isMobile = window.innerWidth <= 768;
  //const iframeHeight = isMobile ? "900px" : "870px";
  //const iframeOffset = isMobile ? "-255px" : "-212px";

  const [formEnviado, setFormEnviado] = useState(false);
  const loadCount = useRef(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleIframeLoad = () => {
    loadCount.current += 1;
    if (loadCount.current > 1) setFormEnviado(true);
  };

  return (
    <section className="contato-section">
      <div className="contato-container">
        <h1 className="contato-title">Entre em contato com a Accium</h1>

        <p className="contato-subtitle">
          Solicite informações, orçamentos ou tire dúvidas sobre nossos produtos
          com nossos especialistas. Respondemos em até 12h durante dias úteis!
        </p>

        <div className="contato-info">
          <div className="contato-info-item">
            <strong>WhatsApp: </strong>
            <a
              href="https://wa.me/5549999140597"
              target="_blank"
              rel="noreferrer"
              className="contato-whatsapp-link"
            >
              (49) 99914-0597
            </a>

            <span className="contato-separador"> | </span>

            <a
              href="https://wa.me/5549988722562"
              target="_blank"
              rel="noreferrer"
              className="contato-whatsapp-link"
            >
              (49) 98872-2562
            </a>
          </div>

          <div className="contato-info-item">
            <strong>Localização: </strong>
            <span>Chapecó (SC) e Região</span>
          </div>

          <div className="contato-info-item">
            <strong>Atendimento: </strong>
            <span>Segunda a sexta • 08h às 18h</span>
          </div>
        </div>

        <div
          className="iframe-mask-contato"
          style={{
            width: "100%",
            height: isMobile ? "850px" : "940px",
            overflow: "hidden",
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            position: "relative",
          }}
        >
          {!formEnviado ? (
            <iframe
              className="contato-iframe"
              src="https://docs.google.com/forms/d/e/1FAIpQLScoDDGMmHZo47gTheU2H-wCJ--xZQIacqIpjwZEv44ayfa3gw/viewform?embedded=true"
              title="Formulário de Contato ACCIUM"
              scrolling="no"
              onLoad={handleIframeLoad}
            />
          ) : (
            <div
              className="mensagem-sucesso"
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                background: "#232323",
                textAlign: "center",
                borderRadius: "16px",
                padding: "40px",
              }}
            >
              <img
                src={logo}
                alt="Logo ACCIUM"
                style={{ width: "100px", marginBottom: "20px" }}
              />

              <h3
                style={{
                  color: "#f67f28",
                  fontSize: "1.8rem",
                  marginBottom: "10px",
                }}
              >
                Obrigado por nos contatar. Em breve um especilista entrará em
                contato!
              </h3>

              <button
                onClick={() => {
                  setFormEnviado(false);
                  loadCount.current = 0;
                }}
                style={{
                  marginTop: "20px",
                  backgroundColor: "#f67f28",
                  color: "#232323",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
              >
                Enviar outro formulário
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Contato;
